// components/InstagramEmbeds.tsx
'use client';

import Script from 'next/script';

declare global {
  interface Window {
    instgrm?: { Embeds: { process: () => void } };
  }
}

export default function InstagramEmbeds() {
  return (
    <Script
      src="https://www.instagram.com/embed.js"
      strategy="afterInteractive"
      onReady={() => window.instgrm?.Embeds.process()}
    />
  );
}